import { WalletOutlined, ArrowUpOutlined, PushpinOutlined, CreditCardOutlined, ArrowDownOutlined } from '@ant-design/icons';

const lancamentos = {
  id: 'group-lancamentos',
  title: 'Lançamentos',
  type: 'group',
  children: [
    {
      id: 'lancamentos-collapse',
      title: 'Lançamentos',
      type: 'collapse',
      icon: WalletOutlined,
      children: [
        {
          id: 'entradas',
          title: 'Entradas',
          type: 'item',
          url: '/entradas',
          icon: ArrowUpOutlined,
          breadcrumbs: false
        },
        {
          id: 'saidas',
          title: 'Saídas',
          type: 'item',
          url: '/saidas',
          icon: ArrowDownOutlined,
          breadcrumbs: false
        },
        {
          id: 'fixos',
          title: 'Fixos',
          type: 'item',
          url: '/fixos',
          icon: PushpinOutlined,
          breadcrumbs: false
        },
        {
          id: 'cartoes-lancamentos',
          title: 'Cartões',
          type: 'item',
          url: '/cartoes',
          icon: CreditCardOutlined,
          breadcrumbs: false
        }
      ]
    }
  ]
};

export default lancamentos;
